<!-- 로그인 페이지 -->
<template>
  <MainHeader :isLoginPage="false" />
  <div class="main-layout pt-0">
    <div class="dashboard-layout">
      <div class="content-area flex flex-1">
        <div class="flex-1 bg-white flex-col flex justify-center align-middle">
          <LoginForm />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainHeader from "@/components/MainHeader.vue";
import LoginForm from "../components/LoginForm.vue";

export default {
  name: "LoginPage",
  components: {
    LoginForm,
    MainHeader,
  },
  data() {
    return {
      transactions: [],
    };
  },
  methods: {
    handleGlobalAction(action, data) {
      console.log("Global Action:", action, data);
    },
    handleCoinAction(action, coinId) {
      console.log("Coin Action:", action, coinId);
    },
  },
};
</script>

<style scoped>
.dashboard-layout {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.content-area {
  display: flex;
  flex: 1; /* 남은 공간을 채움 */
}

.bg-gray-100 {
  background-color: #f3f4f6;
}
</style>
